<template>
  <div
    :class="['paragrafo-default', { noNegativeMargin }, { overlay }]"
    :style="{ '--bg-color': color }"
  >
    <div :class="['paragrafo-default__wrapper', { overlay }]">
      <div class="paragrafo-default__left-column">
        <TextBlockIcon :icon="icons[icon] || {}" :title="iconTitle" />
      </div>
      <TextBlock
        :title="title"
        :paragraphs="paragraphs"
        :overlay="overlay"
        :noNegativeMargin="noNegativeMargin"
        :link="link"
      />
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
import TextBlock from "../atoms/TextBlock.vue";
import TextBlockIcon from "../atoms/TextBlockIcon.vue";
import {
  benefici,
  focus,
  impegni,
  progetto,
  programmi,
  business,
  thumbs,
  compass,
} from "@/assets/icons/icons.js";
const props = defineProps({
  title: String,
  paragraphs: Object,
  icon: String,
  iconTitle: String,
  color: String,
  link: String,
  overlay: Boolean,
  noNegativeMargin: Boolean,
});

const icons = {
  benefici,
  focus,
  impegni,
  progetto,
  programmi,
  business,
  thumbs,
  compass,
};
</script>

<style lang="scss" scoped>
.paragrafo-default {
  padding: 0 var(--page-padding-h);
  background-color: var(--bg-color, var(--white));

  &__left-column {
    @include leftColumn;
  }

  &__wrapper {
    display: flex;

    @include lineLeft;
    @include lineRight;
    &.overlay {
      &::after {
        // display: none;
        height: calc(100% + 7rem);
        z-index: 2;
        background: #fff;
        .noNegativeMargin & {
          height: 100%;
        }
        .mobile &,
        .tablet & {
          height: 100%;
          border-bottom: none;
        }
      }
    }
    &.noNegativeMargin {
    }
  }
  .desktop & {
    &__wrapper {
      &::before {
        display: none;
      }
    }
    &__left-column {
      &::before {
        display: none;
      }
    }
  }
  .mobile &,
  .tablet & {
    &__wrapper {
      flex-direction: column;
    }
    &__left-column { 

    }
  }
}
</style>
